import {
  describePermission,
  getErrorMessage,
  getModuleFromPermission,
} from "@lib/config/errorMessages";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { ShieldBan } from "lucide-react";
import { UnauthorizedComponent as CommonUnauthorizedComponent } from "@/components/common/UnauthorizedComponent";

export const Route = createFileRoute("/unauthorized")({
  staticData: {
    title: "Accès non autorisé",
    icon: <ShieldBan className="w-5 h-5" />,
    permission: null,
    section: "Authentification",
    order: 100,
  },
  component: function UnauthorizedRouteComponent() {
    const search = useSearch({ from: "/unauthorized" });
    const { module, required, resource } = search;

    // Get module from various sources
    const moduleId = module || getModuleFromPermission(required) || "default";
    const errorConfig = getErrorMessage(moduleId, required);

    // Build dynamic message
    let message = errorConfig.description;
    if (required) {
      const permDescription = describePermission(required);
      if (permDescription) {
        message = `Vous n'avez pas l'autorisation de ${permDescription}.`;
      }
    }

    return (
      <CommonUnauthorizedComponent
        accessedResource={resource || required || "cette ressource"}
        message={message}
        reason={errorConfig.title}
      />
    );
  },
});
